import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import DefaultAvatar from '@components/basics/default-avatar';
import { ImageRetry } from '@components/basics/image-retry';

interface SquareAvatarProps {
  className?: string;
  src?: string;
  size?: number;
  username?: string;
}

const SquareAvatar: FunctionComponent<SquareAvatarProps> = ({
  className,
  src,
  username,
}) => {
  return (
    <div className={className || ''}>
      {src ? (
        <ImageRetry
          className="avatar"
          src={src}
          alt={`${username ? username : null}-avatar`}
        />
      ) : (
        <DefaultAvatar className="avatar" />
      )}
    </div>
  );
};

export default styled(SquareAvatar)`
  width: ${(props) => (props.size ? `${props.size}px` : '100px')};
  height: ${(props) => (props.size ? `${props.size}px` : '100px')};
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  object-fit: cover;
  background-color: ${({ theme }) => theme.colors.secondary};

  .avatar {
    max-width: ${(props) => (props.size ? `${props.size}px` : '100px')};
    width: 100%;
    height: ${(props) => (props.size ? `${props.size}px` : '100px')};
    overflow: hidden;
    position: absolute;
    inset: 0;
    object-fit: cover;
  }
`;
